import React from 'react';
import './index.css';

const Footer = () => {
  return (
    <footer>
      ~ 2021 ~ <br />Made with ❤ (and React) <br /> by Piotr Grzegorczyk.
    </footer>
  )
}

export default Footer
